<template>
  <b-modal id="ModalMemo" size="md" ref="ModalMemo" :title="titleText">
    <div>
      <b-form-textarea rows="7" max-rows="7" v-model="memo" no-resize></b-form-textarea>
    </div>
    <template slot="modal-footer">
      <div class="mt-3 text-center">
        <b-button class="mb-1 ml-1" @click="cancel" variant="outline-primary">취소</b-button>
        <b-button class="mb-1 ml-1" @click="confirm" variant="primary">확인</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    props: ["title" , 'data'],
    name: "ModalMemo",
    data() {
      return {
        memo: this.data !== undefined ? this.data : null,
        titleText : this.title !== undefined ? this.title : '메모'
      }
    },
    methods: {
      open() {
        this.$refs['ModalMemo'].show();
        this.memo = '';
      },
      confirm() {
        if( this.memo === null || this.memo === "") {
          alert('메모를 입력해주세요')
          return false
        } else {
          this.$emit('confirm', this.memo)
          this.$refs['ModalMemo'].hide()
        }
      },
      cancel() {
        this.memo = ''
        this.$refs['ModalMemo'].hide()
      }

    },

  }
</script>
